/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( document ).on( 'click', '.ll-mpf-skip-button', function() {
        // clear all inputs and select fields
        $( '.llgq-current-page input, .llgq-current-page select' ).val( '' ).prop( 'checked', false );

        // trigger next button click
        $( '.llgq-quoter-next' ).trigger( 'click' );
      } );

      $( document ).on( 'gform_post_render', function( event, formId, currentPage ) {
        const currentPageElement = $( `#gform_page_1_${currentPage}` );

        const allowSkip = currentPageElement.find( '.allow-skip' );
        if ( allowSkip.length > 0 && $( '.ll-mpf-skip-button' ).length === 0 ) {
          allowSkip.append( '<button class="ll-mpf-skip-button">None of these</button>' );
        }

        if ( currentPageElement.hasClass( 'split-page' ) && currentPageElement.is( ':visible' ) ) {
          currentPageElement.append( '<img src="../wp-content/themes/suma-life-house/assets/img/mpf-bg.png" alt="MPF Background Image" class="fixed lg:block hidden top-0 right-0 z-50 object-cover w-1/2 h-full pointer-events-none" />' );

          $( '.progress-bar' ).addClass( 'hidden' );
        } else {
          $( '.progress-bar' ).removeClass( 'hidden' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'mpf', COMPONENT );
} )( app );
